import { useEffect, useRef, useState } from 'react'
import { formatTime } from 'utils/time-formatter'
import { ICurrentTimeProps } from './types'
import { editorSelectors } from 'store/features/editor/selectors'
import { useSelector } from 'react-redux'

export const CurrentTime = ({
  isPlaying,
  duration,
  initialTime,
  disabled = false,
  onPause
}: ICurrentTimeProps) => {
  const [currentTime, setCurrentTime] = useState<number>(initialTime)
  const startTimeRef = useRef<number | null>(null)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)
  const isBuffering = useSelector(editorSelectors.isAnyBuffering)

  useEffect(() => {
    setCurrentTime(initialTime)
  }, [initialTime])

  useEffect(() => {
    if (isBuffering && intervalRef.current) {
      clearInterval(intervalRef.current)
      return
    }
    if (isPlaying && !disabled && currentTime < duration) {
      startTimeRef.current = Date.now() - currentTime * 1000

      intervalRef.current = setInterval(() => {
        if (startTimeRef.current === null) return

        const elapsed = (Date.now() - startTimeRef.current) / 1000
        const clamped = Math.min(elapsed, duration)
        setCurrentTime(clamped)
      }, 100)
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [isPlaying, disabled, duration, onPause, currentTime, isBuffering])

  return <span>{formatTime(currentTime)}</span>
}
